export enum Action {
    // AI
    UPDATE_SUGGESTED_LABEL_LIST = '@@UPDATE_SUGGESTED_LABEL_LIST',
    UPDATE_REJECTED_SUGGESTED_LABEL_LIST = '@@UPDATE_REJECTED_SUGGESTED_LABEL_LIST',
    UPDATE_OBJECT_DETECTOR_STATUS = '@@UPDATE_OBJECT_DETECTOR_STATUS',
    UPDATE_POSE_DETECTOR_STATUS = '@@UPDATE_POSE_DETECTOR_STATUS',
    UPDATE_DISABLED_AI_FLAG = '@@UPDATE_DISABLED_AI_FLAG',

    // GENERAL
    UPDATE_PROJECT_DATA = '@@UPDATE_PROJECT_DATA',
    UPDATE_WINDOW_SIZE = '@@UPDATE_WINDOW_SIZE',
    UPDATE_ACTIVE_POPUP_TYPE = '@@UPDATE_ACTIVE_POPUP_TYPE',
    UPDATE_CUSTOM_CURSOR_STYLE = '@@UPDATE_CUSTOM_CURSOR_STYLE',
    UPDATE_CONTEXT = '@@UPDATE_CONTEXT',
    UPDATE_PREVENT_CUSTOM_CURSOR_STATUS = '@@UPDATE_PREVENT_CUSTOM_CURSOR_STATUS',
    UPDATE_IMAGE_DRAG_MODE_STATUS = '@@UPDATE_IMAGE_DRAG_MODE_STATUS',
    UPDATE_AI_MODE_STATUS = '@@UPDATE_AI_MODE_STATUS',
    UPDATE_CROSS_HAIR_VISIBLE_STATUS = '@@UPDATE_CROSS_HAIR_VISIBLE_STATUS',
    UPDATE_ENABLE_PER_CLASS_COLORATION_STATUS = '@@UPDATE_ENABLE_PER_CLASS_COLORATION_STATUS',
    UPDATE_ZOOM = '@@UPDATE_ZOOM',
    UPDATE_HOTKEYS = '@@UPDATE_HOTKEYS',

    // LABELS
    UPDATE_ACTIVE_IMAGE_INDEX = '@@UPDATE_ACTIVE_IMAGE_INDEX',
    UPDATE_IMAGE_DATA_BY_ID = '@@UPDATE_IMAGE_DATA_BY_ID',
    UPDATE_IMAGE_DATA_BATCH = '@@UPDATE_IMAGE_DATA_BATCH',
    ADD_IMAGES_DATA = '@@ADD_IMAGES_DATA',
    UPDATE_IMAGES_DATA = '@@UPDATE_IMAGES_DATA',
    UPDATE_ACTIVE_LABEL_NAME_ID = '@@UPDATE_ACTIVE_LABEL_NAME_ID',
    UPDATE_ACTIVE_LABEL_TYPE = '@@UPDATE_ACTIVE_LABEL_TYPE',
    UPDATE_ACTIVE_LABEL_ID = '@@UPDATE_ACTIVE_LABEL_ID',
    UPDATE_HIGHLIGHTED_LABEL_ID = '@@UPDATE_HIGHLIGHTED_LABEL_ID',
    UPDATE_LABEL_NAMES = '@@UPDATE_LABEL_NAMES',
    UPDATE_TAG_NAMES = '@@UPDATE_TAG_NAMES',
    UPDATE_FIRST_LABEL_CREATED_FLAG = '@@UPDATE_FIRST_LABEL_CREATED_FLAG',
    UPDATE_ANNOTATION_COUNT = '@@UPDATE_ANNOTATION_COUNT',
    UPDATE_AUDIO_URL = '@@UPDATE_AUDIO_URL',
    UPDATE_ANNOTATIONS = '@@UPDATE_ANNOTATIONS',
    UPDATE_SAVESTATUS = '@@UPDATE_SAVESTATUS',
    SET_IMAGE_UNDO_INDEX = '@@SET_IMAGE_UNDO_INDEX',
    UPDATE_VIDEO_TRACKING_ENABLED = '@@UPDATE_VIDEO_TRACKING_ENABLED',
    UPDATE_PENDING_TRACK_ID = '@@UPDATE_PENDING_TRACK_ID',

    // NOTIFICATIONS
    SUBMIT_NEW_NOTIFICATION = '@@SUBMIT_NEW_NOTIFICATION',
    DELETE_NOTIFICATION_BY_ID = '@@DELETE_NOTIFICATION_BY_ID',

    UPDATE_BRIGHTNESS = "@@UPDATE_BRIGHTNESS",
UPDATE_CONTRAST = "@@UPDATE_CONTRAST",
UPDATE_GAMMA = "@@UPDATE_GAMMA",
UPDATE_GRAYSCALE = "@@UPDATE_GRAYSCALE",
UPDATE_AI_ASSIST_MODE = '@@UPDATE_AI_ASSIST_MODE',
UPDATE_AI_ASSIST_STATUS = '@@UPDATE_AI_ASSIST_STATUS',
TOGGLE_AI_ASSIST_FORM = '@@TOGGLE_AI_ASSIST_FORM',
TOGGLE_AI_ASSIST_BUTTONS = '@@TOGGLE_AI_ASSIST_BUTTONS',
UPDATE_TASK_TYPE = "UPDATE_TASK_TYPE",
UPDATE_AI_ASSIST_MODELS = 'UPDATE_AI_ASSIST_MODELS',

    // INLINE LABEL PICKER
    UPDATE_INLINE_LABEL_PICKER = '@@UPDATE_INLINE_LABEL_PICKER',

}
